import {create} from "zustand";

export const useSelectSizeStore = create((set) => ({
    selectSizeState: {
        open: false,
        product: {},
    },

    openModalSelectSize: (product) => set({
        selectSizeState: {
            open: true,
            product
        }
    }),

    closeModalSelectSize: () => set({
        selectSizeState: {
            open: false,
            product: {}
        }
    }),
}));
